const allShoes = require('./shoes.json')

export const shoeColors = shoeName => {
  return [
    ...new Set(
      allShoes.filter(shoe => shoe.name === shoeName).map(shoe => shoe.color)
    )
  ]
}

export const shoeSizes = (shoeName, color) => {
  return allShoes
    .filter(shoe => shoe.name === shoeName && shoe.color === color)
    .map(shoe => shoe.size)
    .sort()
}

export const getEANCode = (shoeName, color, size) => {
  return allShoes.find(
    shoe => shoe.name === shoeName && shoe.size === size && shoe.color === color
  ).shoeEanCode
}

export const shoes = [
  {
    name: 'Seattle Women',
    price: 219.95,
    code: 40201.1,
    link:
      'https://www.xsensible.com/english/hiking-collection/seattle-women_navy-brown_27036.html',
    description: `Hiking and trekking are more popular than ever, and whether you’re in the city or out
      in nature, these solid boots made from smooth nubuck leather are the perfect
      footwear for all action-loving men. The Dry X-Membrane integrated into the Xsensible
      stretch leather ensures your feet stay warm and dry even in wet and cold weather.
      The antiskid, bicolour grip soles featuring Xsensible Balance Technology ensure a
      secure and comfortable fit.`
  },
  {
    name: 'Stockholm Women',
    price: 199.95,
    code: 40202.5,
    link:
      'https://www.xsensible.com/english/hiking-homepage-products/stockholm_black_27037.html',
    description: `Hiking and trekking are more popular than ever, and the ultra-light, softly padded
      Xsensible Hiking shoe is perfect for all outdoor activities. A perfect blend of fashion
      and functionality, with highly flexible, padded and breathable Winter Mesh in
      matching colours, combined with leather. The slightly thicker bi-colour grip sole
      featuring the Xsensible Balance Technology ensures a secure and comfortable fit.`
  },
  {
    name: 'Stockholm Men',
    price: 209.95,
    code: 40402.5,
    link:
      'https://www.xsensible.com/english/hiking-homepage-products/stockholm_black_27037.html',
    description: `Hiking and trekking are more popular than ever, and the ultra-light, softly padded
      Xsensible Hiking shoe is perfect for all outdoor activities. A perfect blend of fashion
      and functionality, with highly flexible, padded and breathable Winter Mesh in
      matching colours, combined with leather. The slightly thicker bi-colour grip sole
      featuring the Xsensible Balance Technology ensures a secure and comfortable fit.`
  },
  {
    name: 'Uppsala',
    price: 199.95,
    code: 40203.1,
    link:
      'https://www.xsensible.com/english/women/sneakers/uppsala_blue_27039.html',
    description: `The Xsensible low hiking shoe – made from soft nubuck leather with appliqués in
      contrasting colours – provides outdoor fun that’s functional and suitable for any type
      of weather. The Dry X-Membrane integrated into the Xsensible stretch leather
      ensures your feet stay warm and dry even in wet and cold weather. The antiskid, bicolour grip soles featuring the tried-and-tested Xsensible Balance Technology
      provide a secure and comfortable fit.`
  },
  {
    name: 'Victoria',
    price: 299.95,
    code: 40204.5,
    link:
      'https://www.xsensible.com/english/hiking-collection/victoria_brown_27042.html',
    description: `Whether you’re taking a stroll around the city or heading outdoors, these functional
      tall boots, made from water-repellent leather, are a perfect fit for active women
      everywhere. These high-quality boots, inspired by hiking and sailing, feature
      Xsensible’s trademark stretch leather and Dry X-Membrane, which keeps feet warm
      in wet and cold weather. You can use the tie string to adjust the tightness. The
      antiskid grip sole featuring Xsensible Balance Technology ensures additional
      comfort.`
  },
  {
    name: 'Alaska',
    price: 219.95,
    code: 40400.1,
    link:
      'https://www.xsensible.com/english/men/sneakers/alaska_black_27044.html',
    description: `Perfect for any outdoor activity and in all weather conditions, these athletic men’s shoes, made from
     soft nubuck leather, will keep your feet warm and dry. This is guaranteed by Xsensible’s trademark stretch leather,
     which is protected by waterrepellent Dry X-Membrane. The antiskid, bicolour grip soles featuring Xsensible Balance
     Technology provide a secure and comfortable fit.`
  },
  {
    name: 'Seattle Men',
    price: 229.95,
    code: 40401.1,
    link:
      'https://www.xsensible.com/english/hiking-homepage-products/seattle-men_brown_27047.html',
    description: `Hiking and trekking are more popular than ever, and whether you’re in the city or out
      in nature, these solid boots made from smooth nubuck leather are the perfect
      footwear for all action-loving men. The Dry X-Membrane integrated into the Xsensible
      stretch leather ensures your feet stay warm and dry even in wet and cold weather.
      The antiskid, bicolour grip soles featuring Xsensible Balance Technology ensure a
      secure and comfortable fit`
  }
]

export const getShoeName = shoeEANCode => {
  const found = allShoes.find(
    shoe => shoe.shoeEanCode === shoeEANCode.toString()
  )
  if (found) {
    return found.name
  }
  return ''
}

export const getShoe = shoeName => {
  const shoe = shoes.find(shoe => shoe.name === shoeName)
  if (shoe) return shoe
}
